import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutNFTDelegation() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>NFT Delegation</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Container>{t0}<Row className="pt-5"><Col>Visit our{" "}<Link href="/delegation/delegation-center">Delegation Center</Link> to get started</Col></Row></Container>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}